import React, { useState, useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import { FormInstance } from 'antd/es/form';
import { RootState } from 'modules';
import { useRecoilState } from 'recoil';
import IndexTypeAnswer from 'components/learning/quiz/components/answerType/IndexTypeAnswer';
import IssueTreeTypeAnswer from 'components/learning/quiz/components/answerType/IssueTreeTypeAnswer';
import ListTypeAnswer from 'components/learning/quiz/components/answerType/ListTypeAnswer';
import { getUrlQuery } from 'libs/utils';
import { EQuizType, CQuizTypeNum, CQuizTypeName, TCurrentProcess, EQuizProcessName } from 'modules/learning';
import { TQuizOption, TQuizAnswer, TGradedAnswer, TCurrentProcessProps, EQuizStep } from 'modules/learning';
import { currentProcessState, gradingLoadingState, isGradedState } from 'modules/learning/recoilState';
import { TModalState } from 'modules/types';
import { Tabs, Button, Spin } from 'antd';
import styled from 'styled-components';
import {
  SecondaryColor,
  device,
  Colors,
  StyledSectionCover,
  StyledCheckIcon,
  StyledCrossIcon,
  StyledIconBackground,
} from 'GlobalStyles';
import KaitusIndexTypeAnswer from './AssessmentIndexTypeAnswer';
import KaitusAssessmentSubModal from './AssessmentSubModal';

const { TabPane } = Tabs;

type TQuizChoiceOptionProps = {
  form: FormInstance;
  options: Array<TQuizOption>;
  setOptions: (x: any) => void;
  answersExceptDefault: Array<TQuizAnswer>;
  setAnswersExceptDefault: (x: any) => void;
  defaultAnswer: Array<TQuizAnswer>;
  setDefaultAnswer: (x: any) => void;
  userAnswer: Array<TQuizOption>;
  setUserAnswer: (x: any) => void;
};

function KaitusAssessmentAnswerSheet({
  form,
  options,
  setOptions,
  answersExceptDefault,
  setAnswersExceptDefault,
  defaultAnswer,
  setDefaultAnswer,
  userAnswer,
  setUserAnswer,
}: TQuizChoiceOptionProps) {
  const history = useHistory();
  const location = useLocation();
  const { step, step_name, answer_type, operation, id } = getUrlQuery(location.search);
  const [editQuizSubModal, setEditQuizSubModal] = useState<TModalState>({
    record: '',
    visible: false,
  });
  const [quizType, setQuizType] = useState<{
    type_num: number;
    type_name: string;
  }>({ type_num: 1, type_name: EQuizType.List });
  const quizState = useSelector((store: RootState) => store.createQuizReducer);
  const [currentProcess, setCurrentProcess] = useRecoilState<TCurrentProcess>(currentProcessState);
  const [gradingLoading, setGradingLoading] = useRecoilState<boolean>(gradingLoadingState);
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);
  const [isGraded, setIsGraded] = useRecoilState<boolean>(isGradedState);

  const handleClickSelectedOption = (clicked: TQuizOption) => {
    if (
      //리스트 타입일 때
      quizState.answer_type === 'list'
    ) {
      //selecedUserAnswer에서 해당 부분들 필터링
      const filterClickedAgainUserAnswer = userAnswer.filter((el: TQuizOption) => {
        return el.id !== clicked.id;
      });
      setUserAnswer(filterClickedAgainUserAnswer);
      const addClickedAgainAnswerToOption = [...options, clicked].sort(function(a, b) {
        return a.content_number - b.content_number;
      }); //배열 ㅇ름차순!!
      setOptions(addClickedAgainAnswerToOption);
    }
  };

  useEffect(() => {
    // answer_type = quizType.type_name;
    if (operation !== 'view') {
      if (id) {
        history.push(
          `/case/quiz/create/${id}?step=${step}&step_name=${step_name}&answer_type=${quizType.type_name}`,
        );
      } else if (!id) {
        history.push(
          `/case/quiz/create?step=${step}&step_name=${step_name}&answer_type=${quizType.type_name}`,
        );
      }
    }
  }, [quizType]);

  useEffect(() => {
    if (id) {
      setQuizType({
        type_num: CQuizTypeNum[quizState.answer_type],
        type_name: quizState.answer_type,
      });
    }
  }, [quizState.id]);

  return (
    <QuizAnswerSheetWrapper
      id={`${EQuizProcessName.Answer}_popper_reference`}
      currentProcess={currentProcess.name === EQuizProcessName.Answer}
    >
      {/* <div>QuizAnswerSheet</div> */}
      {operation === 'view' && (
        <StyledViewModeAnswerSheet quizType={quizState.answer_type}>
          <Tabs>
            <TabPane tab={'답안지'}></TabPane>
          </Tabs>
          {/* 디폴트 답변 */}
          {quizState.answer_type === 'list' && (
            <Spin
              tip='제출중..'
              spinning={(currentUser?.is_drill_membership || quizState.is_sample) && gradingLoading}
            >
              <StyledSectionWrapper>
                {isGraded && <StyledSectionCover />}
                <StyledSelectedAnswerSection isGraded={isGraded}>
                  {quizState.quiz_type !== EQuizStep.SolutionWrapUp && (
                    <div style={{ margin: '20px 20px 0 20px' }}> 선택한 답안 </div>
                  )}
                  {defaultAnswer.map((el: TQuizAnswer) => {
                    //디폴트 답은 무조건 정답 표시
                    return (
                      <Button className='ant-btn-primary'>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <div>{`${el.content_number} . ${el.content}`}</div>
                          {/* {!gradingLoading && isGraded && (
                            <StyledIconBackground
                              type="green"
                              position="relative"
                            >
                              <StyledCheckIcon />
                            </StyledIconBackground>
                          )} */}
                        </div>
                      </Button>
                    );
                  })}
                  {/* 내가 선택한 답변 */}
                  {userAnswer?.map((el: TGradedAnswer) => {
                    return (
                      <Button
                        className={`ant-btn-primary pop`}
                        onClick={() => handleClickSelectedOption(el)}
                      >
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <div>{`${el.content_number} . ${el.content}`}</div>
                          { /*!gradingLoading && isGraded && !el?.is_answer && (
                            <StyledIconBackground type='danger' position='relative'>
                              <StyledCrossIcon />
                            </StyledIconBackground>
                          ) */}
                          { /*!gradingLoading && isGraded && el?.is_answer && (
                            <StyledIconBackground type='green' position='relative'>
                              <StyledCheckIcon />
                            </StyledIconBackground>
                          )*/ }
                        </div>
                      </Button>
                    );
                  })}
                  {//진짜 정답 에서 현재 선택한 정답 수 만큼 뺀만큼 기본 안내 텍스트가 나오도록
                  answersExceptDefault.length >= userAnswer.length &&
                    Array(
                      //실제 선택해야 하는 답변 개수 - 이미 선택한 답변 개수
                      Number(answersExceptDefault.length) - Number(userAnswer.length),
                    )
                      .fill(0)
                      .map((el: any) => (
                        <Button className='btn-disabled'>
                          <div>선택지에서 가장 알맞은 답안을 골라주세요</div>
                        </Button>
                      ))}
                </StyledSelectedAnswerSection>
              </StyledSectionWrapper>
            </Spin>
          )}
          {quizState.answer_type === 'index' && (
            <Spin
              tip='제출중..'
              spinning={(currentUser?.is_drill_membership || quizState.is_sample) && gradingLoading}
            >
              <StyledSectionWrapper>
                {isGraded && <StyledSectionCover />}
                <StyledSelectedAnswerSection isGraded={isGraded}>
                  <div style={{ margin: '20px 20px 0 20px' }}> </div>
                  <KaitusIndexTypeAnswer
                    form={form}
                    options={options}
                    setOptions={setOptions}
                    userAnswer={userAnswer}
                    setUserAnswer={setUserAnswer}
                    defaultAnswer={defaultAnswer}
                    setDefaultAnswer={setDefaultAnswer}
                  />
                </StyledSelectedAnswerSection>
              </StyledSectionWrapper>
            </Spin>
          )}
        </StyledViewModeAnswerSheet>
      )}
      {operation !== 'view' && (
        <StyledMakeAnswerWarpper>
          <Tabs>
            <TabPane
              tab={'답안지'}
              // key={ERoute.MentoringQNA}
            ></TabPane>
          </Tabs>
          <StyledSelectQuizType>
            {`유형${CQuizTypeNum[quizType.type_name]} - ${CQuizTypeName[quizType.type_name]}`}
            <Button
              onClick={() => {
                setEditQuizSubModal({
                  record: quizType,
                  type: 'quizType',
                  visible: true,
                  onFinish: (data: any) => {
                    setQuizType({
                      ...quizType,
                      type_num: CQuizTypeNum[data.quiz_type],
                      type_name: data.quiz_type,
                    });
                  },
                });
              }}
            >
              유형 변경
            </Button>
          </StyledSelectQuizType>
          <StyledAnswerSection style={{ marginTop: '20px', marginLeft: '10px' }}>
            {quizType.type_name === EQuizType.List && (
              <ListTypeAnswer form={form} quizTypeName={quizType.type_name} />
            )}
            {quizType.type_name === EQuizType.Index && <IndexTypeAnswer form={form} />}
            {quizType.type_name === EQuizType.IssueTree && <IssueTreeTypeAnswer form={form} />}
          </StyledAnswerSection>

          <KaitusAssessmentSubModal modalState={editQuizSubModal} setModalState={setEditQuizSubModal} />
        </StyledMakeAnswerWarpper>
      )}
    </QuizAnswerSheetWrapper>
  );
}

export default KaitusAssessmentAnswerSheet;

type TStyledWrapperProps = {
  quizType?: string;
};

type TSolveAgianProps = {
  isGraded?: boolean;
};

const QuizAnswerSheetWrapper = styled.div<TCurrentProcessProps>`
  //💜 도움말에서 해당 파트일 때
  ${(props) => props.currentProcess && 'z-index: 90;'}
  @media screen and ${device.sm} {
    ${(props) => props.currentProcess && 'z-index: unset;'}
  }
  position: relative;
  background-color: ${Colors.white};

  border: 1px solid ${Colors.grey1};
  border-top: none;
  height: 400px;
`;

//사용자 뷰모드
const StyledViewModeAnswerSheet = styled.div<TStyledWrapperProps>`
  & .ant-btn {
    height: 44px;
    text-align: left;
    display: block;
    padding: 0 11px !important;
    /* 리스트 타입 버튼 마진에만 해당 */
    margin: 10px 10px 10px 20px;
  }

  & .ant-spin-nested-loading > div > .ant-spin {
    background-color: #e4e4e4;
    opacity: 0.5;
  }
`;

const StyledSectionWrapper = styled.div`
  position: relative;
  width: inherit;
  height: 355px;
  overflow: scroll;
`;

const StyledSelectedAnswerSection = styled.div<TSolveAgianProps>`
  ${(props) => props.isGraded && 'pointer-events : none'}
`;

//답안지 생성 모드
const StyledMakeAnswerWarpper = styled.div`
  position: relative;
  & .ant-btn {
    margin: 5px;
  }

  & .ant-switch-checked {
    background-color: ${SecondaryColor};
  }

  & .ant-switch {
    width: 20px;
  }
`;

const StyledSelectQuizType = styled.div`
  & .ant-btn {
    height: 35px;
  }
  position: absolute;
  right: 10px;
  top: 0;
`;

const StyledAnswerSection = styled.div`
  width: inherit;
  height: 330px;
  overflow: scroll;
`;
